<div class="auth-separateid-container">
  <div class="header">{{cfetLabels.utf_keep_my_ids_separate.header}}</div>
  <p id="blue_text">{{cfetLabels.utf_keep_my_ids_separate.content1}}</p>
  <p id="gray_text">{{cfetLabels.utf_keep_my_ids_separate.content2}}</p>
  <div>
    <img id="img" src="assets/images/FirstNet.png" alt="Firstnet">
  </div>
  <div class="form-group">
    <form [formGroup]="emailAddressForm">
      <div class="row no-gutters form-row" [class.error]="(emailAddressError || showDupeErrorMsg)">
        <div class="col-md-12 email-input-box">
          <label for="emailAddress" id="email_address">{{cfetLabels.cfet_customer_profile.email_add}}</label>
          <div class="email-address-inputbox">
            <input class="form-control" id="emailId" [(ngModel)]="userid" formControlName="emailAddress" tabindex="0"
              type="text" (blur)="validateEmailAddress()" (change)="onChangeEmail()" autocomplete="off" maxlength="256">
            <div *ngIf="emailAddressError || showDupeErrorMsg" role="alert" [attr.aria-atomic]="true"
              [ngClass]="{'error-msg' : (emailAddressError || showDupeErrorMsg)}">
              <em class="icon-badgealert" aria-hidden="true"></em>
              <span *ngIf="emailAddressError">{{cfetMessages.valid_emailAddress}}</span>
              <span *ngIf="showDupeErrorMsg">{{cfetMessages.emailAlreadyExists}}</span>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <label for="content3_1" id="content3_1">{{cfetLabels.utf_keep_my_ids_separate.content3_1}}
    <label for="content3_2" id="content3_2">{{cfetLabels.utf_keep_my_ids_separate.content3_2}}</label></label>
  <div><a tabindex="0" type="button" id="use_1ID" class="use_1ID" (click)="use1ID($event)" (keyup)="use1ID($event)">
      <em aria-label=""></em>
      {{cfetButtonLabels.button_labels.use1ID}}</a></div>
  <hr>
  <div class="col-12" class="btn-container">
    <a tabindex="0" type="button" id="cancel_link" class="utf-cancel-link" (click)="cancelApplication($event)"
      (keyup)="cancelApplication($event)">
      <em aria-label=""></em>
      {{cfetButtonLabels.button_labels.cancel}}</a>
    <button tabindex="0" type="button" id="btn-continue" class="utf-button-blue" (click)="continue($event)"
      (keyup)="continue($event)" [disabled]="disabledContinueButton"><em aria-label=""></em>
      {{cfetButtonLabels.button_labels.continue}}</button>
  </div>
</div>
<div [ngClass]="showCancelModal ? 'open-eligibility-step-cancel-modal' : 'hide-cancel-modal'">
  <app-cancel-eligibility-step-modal [openModal]="openCancelModal" (closeModal)="closeModal($event)">
  </app-cancel-eligibility-step-modal>
</div>